import { CalculationOverridesInput, GeneralInput, RecordIdInput } from 'src/app/Modules/informate/models';

export class PipeSpecificationCodes {
    pipeCodeId?: string;
    name?: string;
    description?: string;
    active?: boolean;
    pipeSizeType?: number;
    pipeSpecs: PipeSpecs[];
}

export class PipeSpecs {
    name: string;
    pipeSpecId?: string;
    description?: string;
    active: boolean;
    versions: pipeSpecVersion[];
}
export class pipeSpecVersion {
    pipeSpecVersionId: string;
    version: number;
    calculationType: number;
    minimumPipeSizeId: string;
    maximumPipeSizeId: string;
    pipeSizeType: number;
    calculationOverrides?: CalculationOverridesInput;
    others?: GeneralInput;
    recordId?: RecordIdInput;
}
